import { Subject, Observable } from 'rxjs';
import { EventTypes } from '../enum/event.types';

export class EventModel {
  public Type: EventTypes | undefined;
  public Data?: EventBaseData;
}

export abstract class EventBaseData {
  public source!: string;
  private readonly _onAction = new Subject<any>();

  constructor(public isRead?: boolean) {}

  public onAction: Observable<any> = this._onAction.asObservable();

  public execute = (result?: any): void => {
    this._onAction.next(result);

    setTimeout(() => {
      this._onAction.complete();
    }, 1000);
  };
}
